import {
  BSFilterParamEnum,
  type DateRangeFilter,
  type SearchParams,
} from "@/types/bridge-scanner.types";
import dayjs from "dayjs";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export interface BridgeScannerFilterStoreType {
  queryParams: SearchParams;
  dateRange: DateRangeFilter;
  clearParam: (keyName: string) => void;
  clearDateRange: () => void;
  setQueryParams: (keyName: string, value: string) => void;
  setDateParams: (dateRange: DateRangeFilter) => void;
  resetQueryParams: () => void;
  initQueryParams: (
    params: BridgeScannerFilterStoreType["queryParams"],
    dateRange: DateRangeFilter
  ) => void;
  isDateRangeValid: () => boolean;
}

export const useBridgeScannerFiltersStore =
  create<BridgeScannerFilterStoreType>()(
    immer((set, get) => ({
      queryParams: new Map<string, string[]>(),
      dateRange: [null, null],
      clearParam: (keyName) =>
        set((state) => {
          state.queryParams.delete(keyName);
        }),
      clearDateRange: () =>
        set((state) => {
          state.dateRange = [null, null];
        }),
      setQueryParams: (keyName, value) =>
        set((state) => {
          const existing = state.queryParams.get(keyName);

          if (existing) {
            const keyValueExists = existing.indexOf(value);
            if (keyValueExists !== -1) {
              existing.splice(keyValueExists, 1);
            } else existing.push(value);

            state.queryParams.set(keyName, existing);
          } else {
            state.queryParams.set(keyName, [value]);
          }
        }),
      setDateParams: (dateRange) =>
        set((state) => {
          state.dateRange = dateRange;
        }),
      resetQueryParams: () => set({ queryParams: new Map() }),
      initQueryParams: (params, dateRange) =>
        set({
          dateRange,
          queryParams: params,
        }),
      isDateRangeValid: () =>
        get().dateRange.every((val) => val) ||
        get().dateRange.every((val) => val === null),
    }))
  );
